import React, { useEffect, useState } from 'react';
import Post from './Post';
import { db, auth } from '../firebase';

function Home() {
    const [posts, setPosts] = useState([]);
    const [user, setUser] = useState(null);


    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((authUser) => {
            if (authUser) {
                console.log(authUser);
                setUser(authUser);
    
            } else {
                setUser(null);
            }
    
            return () => {
              unsubscribe();
            }
            
            
        })
      }, [user]);

    useEffect(() => {

    

        db.collection('posts').onSnapshot(snapshot => {
    
          setPosts(snapshot.docs.map(doc => ({
    
            id: doc.id,
            post: doc.data()
            
          })));
        })
      }, []);

    return (
        <diV>
    {
    posts.map(({id, post}) => (
      <Post key={id} postId={id} username={post.username} user={user} caption={post.caption} imageUrl={post.imageUrl}/>
    ))
  }
        </diV>
    );
}

export default Home;